import type { RouteRecordRaw } from 'vue-router';

import { Layouts } from '@/layouts/constants/Layout';
import { RouteNames } from '@/router/constants/routeName';

const miscRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: {
      name: RouteNames.Devices,
    },
  },
  {
    path: '/explore-ads-variables',
    component: () => import('@/views/ads-explorer/AdsExplorerOverviewProcedure.vue'),
    name: RouteNames.ExploreAdsVariables,
    meta: {
      layout: Layouts.MODERN,
    },
  },
  {
    path: '/explore-ads-variables/deprecated',
    name: RouteNames.DeprecatedExploreAdsVariables,
    component: () => import('@/views/deprecated/ExploreAds.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: RouteNames.NotFound,
    redirect: {
      name: RouteNames.Devices,
    },
  },
];

export default miscRoutes;
